module.exports = __webpack_public_path__ + "img/pentagon-half.d89e6941.svg";